import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, BottoneAPI, CampoNumero, CampoJSON } from '../components/';
import { CDatiGruppo } from '../Dati';
import ReactJson from 'react-json-view';

interface IGruppoState {
    Dati: Dati.CDatiGruppoAutorizzazioni;
    Gruppo: Dati.CDatiGruppo;
    Limiti: Dati.CRisAPI_DatiLimiti;
    CambiStati: Dati.CRisAPIListaTipi<Dati.CDatiStato>;
    TipoCambioStatoPercorso: Dati.TDictTipo;
    Aggiornare: number;
}

export class Gruppo extends BaseComponent<Glob.IRouteGlobaleProps, IGruppoState> {
    private ID_Gruppo: string = "";

    constructor(props: any) {
        super(props);
        this.state = { Aggiornare: 1, Dati: new Dati.CDatiGruppoAutorizzazioni(), Gruppo: new Dati.CDatiGruppo(), Limiti: new Dati.CRisAPI_DatiLimiti(), CambiStati: new Dati.CRisAPIListaTipi<Dati.CDatiStato>(), TipoCambioStatoPercorso: {}};
        this.ID_Gruppo = (this.props.match.params as any).ID_Gruppo;
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIExtra<Dati.CRisAPIDato<Dati.CDatiGruppoAutorizzazioni>, Dati.CDatiGruppo>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && dati.RisAPI != undefined && dati.RisAPI.Dato != undefined && dati.Extra != undefined) {
            this.setState({ Dati: dati.RisAPI.Dato, Gruppo: dati.Extra });
            let menu = 32;

            var M = Glob.GetMenu();
            M.Main = "Utente";
            M.ID_MenuMain = menu;
            this.props.SetMenu(M);
        }
        if (dati.RisAPI == undefined || dati.RisAPI.Dato.Autorizzazioni.length == 0) {
            return false;
        }
        else {
            return true;
        }
    }


    private OnRisLimiti(sender: ChiamaAPI, Limiti: Dati.CRisAPI_DatiLimiti, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && Limiti.Dati.length > 0) {
            this.setState({ Limiti: Limiti });
        }
        return true;
    }

    private OnRisListaCambiStati(sender: ChiamaAPI, stati: Dati.CRisAPIListaTipi<Dati.CDatiStato>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && stati.Dati.length > 0) {
            this.setState({ CambiStati: stati });
        }
        return true;
    }

    private OnRisListaCambioStatoPercorso(sender: ChiamaAPI, datiPercorso: Dati.CRisAPILista<Dati.CTipo>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            let datiTipoCambioStatoPercorso: Dati.TDictTipo = {};
            for(let i: number = 0; i < datiPercorso.Dati.length; i++)
                datiTipoCambioStatoPercorso[datiPercorso.Dati[i].ID_Chiave] = new Dati.CTipo(datiPercorso.Dati[i].ID_Chiave, datiPercorso.Dati[i].ID_Chiave);
            this.setState({ TipoCambioStatoPercorso: datiTipoCambioStatoPercorso });
        }
        return true;
    }


    protected OnAggiorna(i: number, v: number): any {
        let dati: Dati.CDatiGruppoAutorizzazioni = this.state.Dati;
        if (dati.Autorizzazioni[i].Azione == v)
            dati.Autorizzazioni[i].Azione = dati.Autorizzazioni[i].Azione - 1;
        else if (dati.Autorizzazioni[i].Azione == 2 && v == 1)
            dati.Autorizzazioni[i].Azione = 0;
        else
            dati.Autorizzazioni[i].Azione = v;
        this.setState({ Dati: dati });
    }


    private ControlloAbilitazione(tipo: string, azione: number) {
        switch (tipo) {
            case "Nessuna":
                return (azione <= 0);
            case "Lettura":
                return (azione >= 1);
            case "Scrittura":
                return (azione >= 2);
        }
        return false;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("GRUPPO ERRORE"), dati.ErrTesto);
        }
        else {
            this.ID_Gruppo = dati.MessaggioDati;
            this.props.history.replace("/Gruppo/" + dati.MessaggioDati);
            let datiPrec: Dati.CDatiGruppo = this.state.Gruppo;
            datiPrec.ID_Gruppo = this.ID_Gruppo;
            this.setState({ Gruppo: datiPrec });
            Glob.InfoModaleSuccess(Trad.Trad("GRUPPO"), Trad.TradParam("Gruppo salvato correttamente con ID: {1-S}", [dati.MessaggioDati]));
        }
    }

    private OnClickSalvaLimiti(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("GRUPPO ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("LIMITI"), (Trad.Trad("Limiti aggiornati correttamente")));
        }
    }

    private OnClickSalvaListaCambiStati(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("STATI ERRORE"), dati.ErrTesto);
        }
        else {
            this.setState({ Aggiornare: this.state.Aggiornare + 1 });
            Glob.InfoModaleSuccess(Trad.Trad("STATI"), (Trad.Trad("Stati aggiornati correttamente")));
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("GRUPPO ERRORE"), errore.message);
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPIExtra<Dati.CDatiGruppoAutorizzazioni, Dati.CDatiGruppo>();
        Ingr.IngrApi = this.state.Dati;
        Ingr.Extra = this.state.Gruppo;
        return Ingr;
    }

    private OnInvioSalvaLimiti(sender: BottoneAPI): any {
        var Ingr: Dati.CDatiLimite[] = [];
        Ingr = this.state.Limiti.Dati;
        return Ingr;
    }

    private OnInvioSalvaListaCambiStati(sender: BottoneAPI): any {
        return this.state.CambiStati.Dati;
    }

    public render() {
        if (!this.ControlloAutorizzazione("GruppoController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }
        let VisibileScrittura: string = "hidden";
        if (Glob.AzioneAbilitata("AdminPermessi", Glob.Lettura))
            VisibileScrittura = "";

        let Limiti: any = <div></div>;
        if (this.state.Limiti.Dati != undefined) {
            Limiti = this.state.Limiti.Dati.map((limite, index) =>
                <div className={Glob.DimensioneCSS(12) + " kt-form login-form__group form-group row"} key = { index } >
                    <div className={Glob.DimensioneCSS(2) + " kt-input-icon kt-input-icon--right hidden"}>
                        <label className="col-form-label">{limite.ID_TipoGruppoLimite}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(3) + " kt-input-icon kt-input-icon--right"}>
                        <label className="col-form-label">{Trad.Trad(limite.Tipo)}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(2) + " kt-input-icon kt-input-icon--right"}>
                        <label className="col-form-label">{Trad.Trad(limite.TipoRamo)}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(3) + " kt-input-icon kt-input-icon--right"}>
                        <label className="col-form-label">{Trad.Trad(limite.TipoProdotto)}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(2) + " kt-input-icon kt-input-icon--right"}>
                        <CampoNumero Id={"Limiti.Dati[" + index + "].Valore"} Valore={limite.Valore} OnChange={this.OnChange} Name={"Limiti.Dati[" + index + "].Valore"} Massimo={limite.ValoreMAX} BarraLimiti CSS="form-control kt-input" Icona="la la-money" Scrittura={this._Scrittura && this.ID_Gruppo != ""} />
                    </div>
                </div>
            );
        }

        let Stati: any[] = [];
        //console.warn("TIPI DI STATI: ", this.state.CambiStati.Tipi);
        for (let i: number = 0; i < this.state.CambiStati.Dati.length; i++) {
            //console.warn("STATO SELEZIONATO: ", this.state.CambiStati.Dati[i].ID_TipoCambioStato, this.state.CambiStati.Dati[i].ID_TipoCambioStato);
            Stati.push(<div className="kt-form login-form__group form-group row" key={i}>
                <div className={Glob.DimensioneCSS(1) + " col-form-label"}>
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                        {Trad.Trad("Attivo")}
                        <input type="checkbox" id={"CambiStati.Dati[" + i + "].Attivo"} name={"CambiStati.Dati[" + i + "].Attivo"} checked={this.state.CambiStati.Dati[i].Attivo} onChange={this.OnChange} />
                        <span></span>
                    </label>
                </div>
                <div className={Glob.DimensioneCSS(3) + " col-form-label"}>
                    <label>{Trad.Trad("TipoCambioStato")}</label>
                    <Tipo Campo={"CambiStati.Dati[" + i + "].ID_TipoCambioStato"} ID_ChiaveString={this.state.CambiStati.Dati[i].ID_TipoCambioStato} OnAggiorna={this.OnChange} Dati={this.state.CambiStati.Tipi["CambioStato"]} TradValori={true} />
                </div>

                <div className={Glob.DimensioneCSS(2) + " col-form-label"}>
                    <label>{Trad.Trad("TipoStatoPartenza")}</label>
                    <Tipo
                        Campo={"CambiStati.Dati[" + i + "].ID_TipoStatoPartenza"}
                        ID_ChiaveString={this.state.CambiStati.Dati[i].ID_TipoStatoPartenza}
                        OnAggiorna={this.OnChange}
                        Dati={this.state.CambiStati.Tipi[this.state.CambiStati.Dati[i].ID_TipoCambioStato]}
                        TradValori={true}
                        IgnoraPermessi />
                </div>

                <div className={Glob.DimensioneCSS(2) + " col-form-label"}>
                    <label>{Trad.Trad("TipoStatoArrivo")}</label>
                    <Tipo
                        Campo={"CambiStati.Dati[" + i + "].ID_TipoStatoArrivo"}
                        ID_ChiaveString={this.state.CambiStati.Dati[i].ID_TipoStatoArrivo}
                        OnAggiorna={this.OnChange}
                        Dati={this.state.CambiStati.Tipi[this.state.CambiStati.Dati[i].ID_TipoCambioStato]}
                        TradValori={true}
                        IgnoraPermessi />
                </div>

                <div className={Glob.DimensioneCSS(2) + " col-form-label"}>
                    <label>{Trad.Trad("TipoCambioStatoPercorso")}</label>
                    <Tipo
                        Campo={"CambiStati.Dati[" + i + "].ID_TipoCambioStatoPercorso"}
                        ID_ChiaveString={this.state.CambiStati.Dati[i].ID_TipoCambioStatoPercorso}
                        OnAggiorna={this.OnChange}
                        TradValori={true}
                        Dati={this.state.TipoCambioStatoPercorso}
                        IgnoraPermessi
                         />
                </div>
                
                <div className={Glob.DimensioneCSS(2) + " col-form-label"}>
                    <label>{Trad.Trad("Ordine")}</label>
                    <input type="number" className="form-control kt-input" name={"CambiStati.Dati[" + i + "].Ordine"} value={this.state.CambiStati.Dati[i].Ordine} onChange={this.OnChange} />
                </div>

                <div className={Glob.DimensioneCSS(12) + " col-form-label"}>
                    <label>{Trad.Trad("AzioniJSON")}</label>
                    <CampoJSON Id={"CambiStati.Dati[" + i + "].AzioniJSON"} Name={"CambiStati.Dati[" + i + "].AzioniJSON"} Valore={this.state.CambiStati.Dati[i].AzioniJSON} OnChange={this.OnChange} />
                </div>

                <div className={Glob.DimensioneCSS(12) + " col-form-label"}>
                    <label>{Trad.Trad("ListaGruppiNotificaJSON")}</label>
                    <CampoJSON Id={"CambiStati.Dati[" + i + "].ListaGruppiNotificaJSON"} Name={"CambiStati.Dati[" + i + "].ListaGruppiNotificaJSON"} Valore={this.state.CambiStati.Dati[i].ListaGruppiNotificaJSON} OnChange={this.OnChange} />
                </div>

                <div className={Glob.DimensioneCSS(12) + " col-form-label"}>
                    <label>{Trad.Trad("Note")}</label>
                    <textarea className="form-control kt-input" name={"CambiStati.Dati[" + i + "].Note"} value={this.state.CambiStati.Dati[i].Note} onChange={this.OnChange} />
                </div>
            </div>);
        }

        let Autorizzazioni: any = <div></div>;
        if (this.state.Dati.Autorizzazioni != undefined && this.state.Gruppo != undefined) {
            Autorizzazioni = this.state.Dati.Autorizzazioni.map((dato, index) =>
                <div className={Glob.DimensioneCSS(12) + " kt-form login-form__group form-group row"} key={index}>
                    <label className={Glob.DimensioneCSS(2) + " col-form-label hidden"}>{dato.ID_Funzione}</label>
                    <label className={Glob.DimensioneCSS(4) + " col-form-label"}>{Trad.Trad(dato.Descrizione)}</label>
                    <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("Nessuna")}</label>
                    <div className={Glob.DimensioneCSS(1)}>
                        <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--metal">
                            <label>
                                <input name="" type="checkbox" checked={this.ControlloAbilitazione("Nessuna", dato.Azione)} onChange={() => this.OnAggiorna(index, 0)} />
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("Lettura")}</label>
                    <div className={Glob.DimensioneCSS(1)}>
                        <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--success">
                            <label>
                                <input name="" type="checkbox" checked={this.ControlloAbilitazione("Lettura", dato.Azione)} onChange={() => this.OnAggiorna(index, 1)} />
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <label className={Glob.DimensioneCSS(1) + " col-form-label"}>{Trad.Trad("Scrittura")}</label>
                    <div className={Glob.DimensioneCSS(1)}>
                        <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--success">
                            <label>
                                <input name="" type="checkbox" checked={this.ControlloAbilitazione("Scrittura", dato.Azione)} onChange={() => this.OnAggiorna(index, 2)} />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            );
        }
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon "><i className="fa fa-users"></i></span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Gruppo")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                            <NavLink to="/Gruppo/0" className={"kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg " + this._VisibileScrittura} title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form login-form kt-form login-form--fit kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">

                    <div className="form-group kt-form login-form__group row">
                        <div className={Glob.DimensioneCSS(4)}>
                            <label>{Trad.Trad("ID")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control" value={this.ID_Gruppo} readOnly />
                            </div>
                        </div>
                        <div className={Glob.DimensioneCSS(8)}>
                            <label>{Trad.Trad("Gruppo")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control" value={this.state.Gruppo.Gruppo || ""} id="Gruppo" name="Gruppo.Gruppo" onChange={(e) => { this.OnChange(e) }} />
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet kt-portlet--full-height kt-portlet--tabs">
                        <div className="kt-portlet__head">
                            <div className="portlet__head-tools">
                                <ul className="nav nav-tabs kt-tabs kt-tabs-line kt-tabs-line--left kt-tabs-line--brand" role="tablist">
                                    <li className="nav-item kt-tabs__item">
                                        <a className="nav-link tabs__link active show" data-toggle="tab" href="#kt_limiti" role="tab" aria-selected="false">{Trad.Trad("Limiti")}</a>
                                    </li>
                                    <li className={"nav-item kt-tabs__item " + VisibileScrittura}>
                                        <a className="nav-link tabs__link" data-toggle="tab" href="#kt_autorizzazioni" role="tab" aria-selected="false">
                                            <i className="flaticon-share lt--hide"></i>
                                            {Trad.Trad("Autorizzazioni")}
                                        </a>
                                    </li>
                                    <li className="nav-item kt-tabs__item">
                                        <a className="nav-link tabs__link" data-toggle="tab" href="#kt_stati" role="tab" aria-selected="false">{Trad.Trad("Stati")}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="tab-content kt-padding-30">
                            <div className="tab-pane" id="kt_autorizzazioni">
                                <div className="kt-form login-form__group form-group row">
                                    <div className="kt-form login-form__group form-group row col-12">
                                        <label className={Glob.DimensioneCSS(2) + " col-form-label hidden"}><h6>{Trad.Trad("Funzione")}</h6></label>
                                        <label className={Glob.DimensioneCSS(4) + " col-form-label"}><h6>{Trad.Trad("Descrizione funzione")}</h6></label>
                                        <label className={Glob.DimensioneCSS(6) + " col-form-label TextCenter"}><h6>{Trad.Trad("Abilitazione funzione")}</h6></label>
                                    </div>
                                </div>
                                <div className="kt-form login-form__group form-group row">
                                    {Autorizzazioni}
                                    {this.displayStatusButton()}
                                </div>
                                <div className="kt-portlet__foot kt-portlet__foot--fit">
                                    <div className="kt-form login-form__actions kt-form login-form__actions--right">
                                        <div className="row">
                                            <div className="col kt-form__actions kt-form__actions--right">
                                                <ChiamaAPI Aggiornare={this.state.Aggiornare} URL={"/api/Gruppo/ListaAutorizzazioni?ID_Gruppo=" + this.ID_Gruppo} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                                                <BottoneAPI Default={false} Testo={Trad.Trad("Salva")} URL="/api/Gruppo/" Metodo="POST" OnClick={(s, d) => this.OnClickSalva(s, d)} OnInvio={(s) => this.OnInvioSalva(s)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane active show" id="kt_limiti">
                                <div className="kt-form login-form__group form-group row">
                                    {Limiti}
                                    {this.displayStatusButton()}
                                </div>
                                <div className="kt-portlet__foot kt-portlet__foot--fit">
                                    <div className="kt-form login-form__actions kt-form login-form__actions--right">
                                        <div className="row">
                                            <div className="col kt-form__actions kt-form__actions--right">
                                                <ChiamaAPI Aggiornare={this.state.Aggiornare} URL={"/api/Gruppo/ListaLimiti?ID_Gruppo=" + this.ID_Gruppo} OnRis={(s, d, dn) => this.OnRisLimiti(s, d, dn)} OnErrore={this.OnErrore} />
                                                <BottoneAPI Default={false} Testo={Trad.Trad("Salva")} URL="/api/Gruppo/AggiornaLimiti" Metodo="POST" OnClick={(s, d) => this.OnClickSalvaLimiti(s, d)} OnInvio={(s) => this.OnInvioSalvaLimiti(s)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura && this.ID_Gruppo != ""} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane" id="kt_stati">
                                {Stati}
                                {this.displayStatusButton()}
                                <div className="kt-portlet__foot kt-portlet__foot--fit">
                                    <div className="kt-form login-form__actions kt-form login-form__actions--right">
                                        <div className="row">
                                            <div className="col kt-form__actions kt-form__actions--right">
                                                <ChiamaAPI Aggiornare={this.state.Aggiornare} URL={"/api/Gruppo/ListaCambiStati?ID_Gruppo=" + this.ID_Gruppo} OnRis={(s, d, dn) => this.OnRisListaCambiStati(s, d, dn)} OnErrore={this.OnErrore} />
                                                <ChiamaAPI Aggiornare={this.state.Aggiornare} URL={"/api/Tipi/ListaTipi?ID_TipoContesto=CambioStatoPercorso"} OnRis={(s, d, dn) => this.OnRisListaCambioStatoPercorso(s, d, dn)} OnErrore={this.OnErrore} />
                                                <BottoneAPI Default={false} Testo={Trad.Trad("Salva")} URL="/api/Gruppo/AggiornaListaCambiStati" Metodo="POST" OnClick={(s, d) => this.OnClickSalvaListaCambiStati(s, d)} OnInvio={(s) => this.OnInvioSalvaListaCambiStati(s)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura && this.ID_Gruppo != ""} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>;
    }

    private displayStatusButton() {
        return (<div className="kt-portlet__head status-icon">
            <div className="portlet__head-tools">
                <ul className="kt-portlet__nav">
                    <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                        <a href="#" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" onClick={(e) => { e.preventDefault(); let stato: Dati.CDatiStato = new Dati.CDatiStato(); stato.ID_Gruppo = this.ID_Gruppo; stato.AzioniJSON = '[]'; stato.ListaGruppiNotificaJSON = '[]'; this.state.CambiStati.Dati.push(stato); this.forceUpdate(); }}><i className="fa fa-plus"></i></a>
                    </div>
                </ul>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/form/Gruppo.tsx